import { Component, OnInit, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { Capacitor } from '@capacitor/core';
import { rehydrateNativeAppState } from './shared/core/state/core.reducer';
import { TenantService } from './shared/services/tenant.service';

@Component({
  selector: 'black-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnInit {
  private store = inject(Store);
  public tenantService = inject(TenantService);

  title = 'bse-website';

  async ngOnInit(): Promise<void> {
    // Rehydrate state from native storage on app initialization
    if (Capacitor.isNativePlatform()) {
      await rehydrateNativeAppState(this.store);
    }
  }
}
